import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '2560px',
};
export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};
const ColoredContainer = styled.div`
  flex-shrink: 0;
  width: 100%;
  justify-content: center;
  background: radial-gradient(
    83.2% 403.89% at 24.77% 50%,
    #009f9b 0%,
    #8eb833 100%
  );
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const InnerContainer = styled.div`
  display: flex;
  width: 1140px;
  padding-top: 50px;
  padding-bottom: 50px;
  gap: 40px;
  @media only screen and ${device.tablet} {
    flex-direction: column;
    width: 345px;
  }
`;
const Featured = styled.button`
  display: flex;
  flex-direction: column;
  background: none;
  border: none;
`;
const Title = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 20px;
  color: #0b3f3e;
  text-align: left;
`;

const FeaturedImage = styled.img`
  width: 540px;
  background: #fbbc05;
  margin-top: 20px;
  border-radius: 14px;
  box-shadow: 4px 4px 6.7px 0px #00000040;
  @media only screen and ${device.tablet} {
    width: 100%;
    height: 245px;
  }
  &:hover {
    cursor: pointer;
  }
`;

const FeaturedContent = styled.div`
  // display: -webkit-box;
  // -webkit-line-clamp: 2; /* Limits text to 3 lines */
  // -webkit-box-orient: vertical;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: normal; /* Ensures wrapping */
  // max-height: 4.5em; /* Adjust based on line height (1.5em * 3) */
  // line-height: 1.5em; /* Sets consistent line height */
  // width: 100%; /* Ensures proper wrapping */
  font-family: Inter;
  font-weight: 500;
  font-size: 40px;
  color: #fafafa;
  margin-top: 10px;
  max-width: 510px;
  text-align: left;
  @media only screen and ${device.tablet} {
    font-size: 28px;
  }
  &:hover {
    cursor: pointer;
  }
`;

const EditorsPicks = styled.div`
  display: flex;
  flex-direction: column;
`;

const ListContainer = styled.button`
  display: flex;
  margin-top: 20px;
  gap: 10px;
  border: none;
  background: none;
  @media only screen and ${device.tablet} {
    flex-direction: column;
    padding: unset;
  }
  &:hover {
    cursor: pointer;
  }
`;
const EditorImage = styled.img`
  height: 182px;
  background: #fafafa;
  border-radius: 14px;
  box-shadow: 4px 4px 6.7px 0px #00000040;
  @media only screen and ${device.tablet} {
    width: 300px;
    height: 210px;
  }
`;
const EditorContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 324px;
`;
const EditorButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 30px;
  padding-bottom: 10px;
`;
const EditorButton = styled.div`
  height: 25px;
  padding-right: 7px;
  padding-left: 7px;
  border-radius: 20px;
  background: #083359;
  font-family: Inter;
  font-weight: 500;
  font-size: 12px;
  color: #a0d925;
  display: flex;
  width: 63px;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

const EditorContentText = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  max-height: 4.5em;
  line-height: 1.5em;
  width: 310px;
  font-family: Inter;
  font-weight: 500;
  font-size: 18px;
  text-align: left;
  color: #fafafa;
  margin-top: 5px;
`;
const DateConteiner = styled.div`
  align-items: center;
  display: flex;
  gap: 7px;
`;

const DateText = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 12px;
  color: #d9d9d9;
`;

const BlogFeaturedSection = ({ blogData }) => {
  let navigate = useNavigate();

  return (
    <ColoredContainer>
      <InnerContainer>
        <Featured
          onClick={() => {
            navigate(`/blog/${blogData[0]?.id}`);
          }}
        >
          <Title>Featured</Title>
          <FeaturedImage src={blogData[0]?.image} />
          <FeaturedContent title={blogData[0]?.heading}>
            {blogData[0]?.heading}
          </FeaturedContent>
          <EditorButton style={{ marginTop: '10px' }}>
            {'Read More'}
          </EditorButton>
        </Featured>
        <EditorsPicks>
          <Title>Editor’s Picks</Title>
          {blogData?.slice(1, 4)?.map((data) => {
            return (
              <ListContainer
                onClick={() => {
                  navigate(`/blog/${data?.id}`);
                }}
              >
                <EditorImage src={data?.image} />
                <EditorContent>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <EditorContentText title={data?.heading}>
                      {data?.heading}
                    </EditorContentText>
                    <DateConteiner>
                      <DateText>{data?.date}</DateText>
                      <div
                        style={{
                          width: '5px',
                          height: '5px',
                          borderRadius: '2.5px',
                          backgroundColor: '#D9D9D9',
                        }}
                      />
                      <DateText>{data?.time}</DateText>
                    </DateConteiner>
                  </div>
                  <EditorButtonContainer>
                    <EditorButton>{'Read More'}</EditorButton>
                  </EditorButtonContainer>
                </EditorContent>
              </ListContainer>
            );
          })}
        </EditorsPicks>
      </InnerContainer>
    </ColoredContainer>
  );
};
export default BlogFeaturedSection;
